import React, { useMemo } from "react";

import { boxForwardRef } from "../../../../../helpers/common/Box/Box";
import { Content } from "../../../../Content";
import { createDisplayNameForButtonCellElement } from "../../utils/getDisplayName";
import { createTestIdForButtonCellElement } from "../../utils/getTestId";

import type { BoxComponentWithDefault } from "../../../../../helpers/common/Box/Box";
import type { OmitOfUnion } from "../../../../../types/react";
import type { ContentTextProps } from "../../../../Content/Content/components/Text/ContentText";

export type ButtonCellSubtitleProps = OmitOfUnion<
    ContentTextProps,
    | "textCase"
    | "underline"
    | "strikethrough"
    | "lineHeight"
    | "truncateStyle"
    | "asList"
    | "quote"
    | "italic"
>;

const SUBTITLE_TEST_ID = createTestIdForButtonCellElement("subtitle");

export const ButtonCellSubtitle = boxForwardRef<
    BoxComponentWithDefault<"span", ButtonCellSubtitleProps, "className">
>(({ children, view = "secondary", customColorsStyles, ...props }, ref) => {
    const viewProps = useMemo(() => {
        if (view === "custom") {
            if (customColorsStyles) {
                return { view, customColorsStyles };
            }

            return {};
        }

        return { view };
    }, [view, customColorsStyles]);

    return children ? (
        <Content.Text
            {...props}
            {...viewProps}
            data-tsid={SUBTITLE_TEST_ID}
            ref={ref}
        >
            {children}
        </Content.Text>
    ) : null;
});

ButtonCellSubtitle.displayName =
    createDisplayNameForButtonCellElement("Subtitle");

export default ButtonCellSubtitle;
